<template>
  <div class="personal-center" :style="{ '--themeColor': $store.state.themeInfo.themeColor }">
    <div v-if="containsMiceLink">
      <van-sticky>
        <head-bar :title="headTitle" @onClickLeft="onClickLeft" :right="false" />
      </van-sticky>

      <div v-if="initializing" class="loading-page">
        <div class="loading-card">
          <van-skeleton title avatar :row="6" :loading="true" />
        </div>
        <div class="loading-card loading-card-small">
          <van-skeleton title :row="4" :loading="true" />
        </div>
      </div>

      <div v-else-if="isSearch">
        <div v-if="!searchSuccess" class="login-card">
          <van-form @submit="onSubmit">
            <van-field
              v-model="form.phone"
              required
              label="手机号"
              placeholder="手机号"
              type="digit"
              :error-message="phoneErrorMsg"
              maxlength="11"
              @input="phoneErrorMsg = ''"
              :rules="[{ required: true, message: '请填写正确手机号码', pattern: phoneRules, trigger: 'onChange' }]"
            >
              <template #label><span>手</span><span>机</span><span>号</span></template>
            </van-field>
            <van-field
              v-model="form.verifyCode"
              center
              required
              clearable
              label="短信验证码"
              type="digit"
              placeholder="请输入短信验证码"
              maxlength="6"
              :rules="[{ required: true, message: '请输入验证码', trigger: 'onChange' }]"
            >
              <template #button>
                <van-button
                  size="small"
                  native-type="button"
                  :disabled="waitCode"
                  :style="{ background: $store.state.themeInfo.themeColor, border: 'none', color: '#fff' }"
                  @click="sendCode"
                >{{ sendCodeText }}</van-button>
              </template>
              <template #label><span>短</span><span>信</span><span>验</span><span>证</span><span>码</span></template>
            </van-field>
            <div class="login-actions">
              <van-button
                block
                round
                type="info"
                native-type="submit"
                :loading="loading"
                :disabled="loading"
                :style="{ background: $store.state.themeInfo.themeColor, border: 'none' }"
              >登录</van-button>
            </div>
            <div class="register" @click="registerClick">立即报名</div>
          </van-form>
        </div>

        <div v-else-if="userInfo" class="page-content">
          <template v-if="active === 1">
            <article class="card main-profile-card">
            <div class="main-card-header">
              <div class="event-title">{{ $store.state.miceInfo.miceName }}</div>
            </div>
            <div class="main-card-body">
              <div class="avatar-wrapper">
                <div class="avatar">
                  <img :src="userInfo.faceUrl || defaultAvatar" alt="头像" @error="useDefaultAvatar" />
                </div>
              </div>
              <div class="user-name">{{ userInfo.name || '--' }}</div>
              <div class="user-company" v-if="userInfo.company">{{ userInfo.company }}</div>
              <div class="status-badge" :class="`is-${statusMeta.type}`">
                <span class="status-icon">{{ statusMeta.icon }}</span>
                <span>{{ statusMeta.text }}</span>
              </div>

              <div class="info-list">
                <div class="info-item"><span class="info-label">参会人</span><span class="info-value">{{ userInfo.name || '--' }}</span></div>
                <div class="info-item"><span class="info-label">手机号</span><span class="info-value">{{ userInfo.phone || '--' }}</span></div>
                <div class="info-item"><span class="info-label">单位</span><span class="info-value">{{ userInfo.company || '--' }}</span></div>
                <div class="info-item"><span class="info-label">注册时间</span><span class="info-value">{{ userInfo.createTime || '--' }}</span></div>
              </div>

              <div v-if="statusMeta.type !== 'pending' && groupList.length" class="state-panel is-visible">
                <div class="venue-list">
                  <div v-for="(item, index) in groupList" :key="index" class="venue-card-item">
                    <div class="venue-card-top">
                      <span class="venue-name" v-html="groupNameFilter(item.name)"></span>
                      <span class="tag-result success" v-if="statusMeta.type === 'approved' && +item.state === 1">准时参会</span>
                      <span class="tag-result danger" v-else>很抱歉，坐席已满</span>
                    </div>
                    <div class="venue-info-row"><span class="venue-info-icon">◷</span><span>{{ item.date | groupDateFilter }}</span></div>
                    <div class="venue-info-row"><span class="venue-info-icon">⌖</span><span>{{ item.address || '--' }}</span></div>
                  </div>
                </div>
              </div>

              <div v-if="statusMeta.type === 'failed'" class="failure-box">
                <div class="failure-box-content">
                  <p class="failure-title">报名结果：很抱歉，坐席已满</p>
                  <p>很抱歉，您报名的{{ $store.state.miceInfo.miceName }}活动坐席已满，感谢您的参与！</p>
                </div>
              </div>

              <div v-if="auditStatus && groupList.length" class="qr-section">
                <van-divider dashed>签到二维码</van-divider>
                <div class="qr-code-wrapper" @click="refreshCode">
                  <vue-qr v-if="userInfo.code" :text="userInfo.code" :size="200" />
                  <div v-if="freshLoading" class="loading-mask"><van-loading type="spinner" /></div>
                </div>
                <p class="qr-tip">出示二维码，签到更方便</p>
                <p class="qr-tip">二维码一分钟过期，点击二维码刷新</p>
              </div>
            </div>
            </article>

          <article class="card profile-form-card">
            <div class="card-header">
              <h2>报名信息</h2>
            </div>
            <div class="detail-info-list">
              <div class="detail-info-item detail-info-item-venues">
                <span class="detail-info-label">报名会场</span>
                <div class="detail-info-value applied-venues">
                  <span v-for="(item, index) in groupList" :key="index" class="applied-venue-tag">{{ item.name }}</span>
                  <span v-if="!groupList.length" class="applied-venue-tag">--</span>
                </div>
              </div>
              <div class="detail-info-item"><span class="detail-info-label">姓名</span><span class="detail-info-value">{{ userInfo.name || '--' }}</span></div>
              <div class="detail-info-item"><span class="detail-info-label">手机号</span><span class="detail-info-value">{{ userInfo.phone || '--' }}</span></div>
              <div class="detail-info-item"><span class="detail-info-label">所在地</span><span class="detail-info-value">{{ userInfo.address || userInfo.location || '--' }}</span></div>
              <div class="detail-info-item"><span class="detail-info-label">单位</span><span class="detail-info-value">{{ userInfo.company || '--' }}</span></div>
              <div class="detail-info-item"><span class="detail-info-label">职务</span><span class="detail-info-value">{{ userInfo.position || userInfo.job || '--' }}</span></div>
              <div class="detail-info-item"><span class="detail-info-label">身份证号</span><span class="detail-info-value">{{ maskIdCard(userInfo.idCard) }}</span></div>
              <div class="detail-info-item"><span class="detail-info-label">注册时间</span><span class="detail-info-value">{{ userInfo.createTime || '--' }}</span></div>
            </div>
          </article>
          </template>
          <component
            v-else
            :is="witchComp"
            :userInfo="userInfo"
            :arrangement="arrangement"
            :wzVipJourneys="wzVipJourneys"
            :vipUserInfo="vipUserInfo"
            :shareType="shareType"
            @switchType="switchType"
            @changeUser="changeUser"
          />
        </div>
      </div>
      <div v-else class="loading-page">
        <div class="loading-card">
          <van-skeleton title avatar :row="6" :loading="true" />
        </div>
      </div>

      <van-overlay
        v-if="registrationNotStarted"
        :show="true"
        :lock-scroll="true"
        class="registration-coming-overlay"
        role="dialog"
        aria-modal="true"
        aria-label="报名尚未开始"
      >
        <div class="registration-coming-card" @click.stop>
          <div class="registration-coming-title">敬请期待</div>
        </div>
      </van-overlay>
    </div>
    <no-page v-else />
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import vueQr from 'vue-qr'
import headBar from '@/components/headBar/headBar'
import noPage from '@/components/noPage/noPage'
import Share from '@/views/user/components/share/index'
import planList from '@/views/user/components/planeList/index'
import vipJourney from '@/views/user/components/vipJourney/index'
import webConfig from '@/config'
import { getRegistrationStatus, getRegistrationMessage } from '@/utils/registrationTime'

export default {
  name: 'PersonalCenter',
  components: { vueQr, headBar, noPage, Share, planList, vipJourney },
  filters: {
    groupDateFilter(date) {
      if (!date) return '--'
      const end = date.lastIndexOf('-')
      const start = date.slice(0, end).trim()
      const separator = start.lastIndexOf(' ')
      if (separator === -1) return `${start}开始`
      const startTime = start.slice(separator + 1)
      const period = parseInt(startTime.slice(0, 2), 10) <= 12 ? '上午' : '下午'
      return `${start.slice(0, separator)} ${period} ${startTime}开始`
    }
  },
  data() {
    return {
      containsMiceLink: false,
      miceLink: '',
      isSearch: false,
      initializing: true,
      searchSuccess: false,
      loading: false,
      freshLoading: false,
      waitCode: false,
      interval: null,
      phoneErrorMsg: '',
      sendCodeText: '获取验证码',
      phoneRules: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      userInfo: null,
      form: { phone: '', verifyCode: '' },
      active: 1,
      arrangement: [],
      wzVipJourneys: [],
      vipUserInfo: {},
      shareType: 'normal',
      isSubmitQuestion: false,
      defaultAvatar: 'https://pic1.imgdb.cn/i/6mQmt2T9rpvI2xqXyvqAQR'
    }
  },
  computed: {
    headTitle() {
      return this.userInfo && this.userInfo.type === 1 ? '工作人员个人中心' : '个人中心'
    },
    registrationNotStarted() {
      if (this.initializing || this.searchSuccess || this.userInfo) return false
      return getRegistrationStatus(
        this.$store.state.miceInfo.registerStartTime,
        this.$store.state.miceInfo.registerDeadline
      ) === 'before'
    },
    witchComp() {
      if (this.active === 2) return 'Share'
      if (this.active === 3) return this.wzVipJourneys.length ? 'vipJourney' : 'planList'
      return 'signForm'
    },
    groupArray() {
      return this.$store.state.groupInfo.groupArray || []
    },
    groupList() {
      if (!this.userInfo || !this.userInfo.groupInfo) return []
      let source = []
      try {
        source = typeof this.userInfo.groupInfo === 'string' ? JSON.parse(this.userInfo.groupInfo) : this.userInfo.groupInfo
      } catch (error) {
        return []
      }
      if (!Array.isArray(source)) return []
      return source.map(item => {
        const parts = String(item.state || '').split('-')
        const group = this.groupArray.find(groupItem => groupItem.groupLink === (parts[0] || item.groupLink))
        if (!group && !item.name) return null
        return {
          name: (group && group.name) || item.name || '--',
          address: (group && group.address) || item.address || '--',
          date: group
            ? `${group.startDate || ''} ${group.startTime ? group.startTime.substr(0, 5) : ''}-${group.endTime ? group.endTime.substr(0, 5) : ''}`.trim()
            : (item.date || ''),
          state: parts[1] || item.state
        }
      }).filter(Boolean)
    },
    auditStatus() {
      return this.$store.state.miceInfo.isAudit === 1
        ? !!(this.userInfo && this.userInfo.auditStatus === 1)
        : true
    },
    statusMeta() {
      if (this.$store.state.miceInfo.isAudit !== 1 || (this.userInfo && this.userInfo.auditStatus === 1)) {
        return { type: 'approved', text: '报名审核通过', icon: '✓' }
      }
      if (this.userInfo && this.userInfo.auditStatus === 3) {
        return { type: 'pending', text: '报名信息审核中', icon: '◷' }
      }
      return { type: 'failed', text: '很抱歉，坐席已满', icon: '×' }
    }
  },
  methods: {
    wait(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },
    maskIdCard(idCard) {
      if (!idCard) return '--'
      const value = String(idCard).trim()
      if (value.length <= 4) return value.replace(/./g, '*')
      if (value.length <= 8) return `${value.slice(0, 2)}${'*'.repeat(value.length - 4)}${value.slice(-2)}`
      return `${value.slice(0, 3)}${'*'.repeat(value.length - 7)}${value.slice(-4)}`
    },
    onClickLeft() {
      if (this.$parent && this.$parent.onChange) {
        this.$parent.onChange(0)
      } else {
        this.$router.push(`/index/${this.miceLink}`)
      }
    },
    registerClick() {
      const status = getRegistrationStatus(
        this.$store.state.miceInfo.registerStartTime,
        this.$store.state.miceInfo.registerDeadline
      )
      if (status !== 'open') {
        Toast({
          message: status === 'after' ? webConfig.messages.registrationClosed : getRegistrationMessage(status),
          position: 'middle'
        })
        return
      }
      // 普通报名入口固定为嘉宾，清除此前工作人员通道的类型影响。
      sessionStorage.setItem('type', '0')
      this.$router.push(`/signup/${this.miceLink}`)
    },
    useDefaultAvatar(event) {
      if (event && event.target && event.target.src !== this.defaultAvatar) event.target.src = this.defaultAvatar
    },
    groupNameFilter(name) {
      if (!name) return '--'
      return name.replace(/\s{2,}|\s/g, '<br>')
    },
    async onSubmit() {
      this.loading = true
      this.arrangement = []
      const payload = { ...this.form, miceLink: this.$store.state.miceInfo.miceLink || this.miceLink }
      const result = await this.$http.post(this.$baseURL.index.searchByPhone(), payload, 1)
      this.loading = false
      if (result.code === 200 && result.data) {
        this.userInfo = result.data.backstageApply || null
        if (result.data.wzVipJourneys) {
          this.wzVipJourneys = result.data.wzVipJourneys
          if (this.wzVipJourneys.length) {
            this.vipUserInfo.name = this.wzVipJourneys[0].vipName
            this.vipUserInfo.phone = this.$utils.handlePhone(this.wzVipJourneys[0].vipPhone)
            this.shareType = 'vip'
          }
          this.active = this.userInfo ? 1 : 3
        }
        this.arrangement.push({ apply: result.data.backstageApply, hotels: result.data.hotels, meals: result.data.meals, seats: result.data.seats, vehicles: result.data.vehicles })
        this.searchSuccess = !!(this.userInfo || this.wzVipJourneys.length)
        if (!this.searchSuccess) Dialog.alert({ title: '提示', message: '未查询到您的报名信息' })
      } else {
        Dialog.alert({ title: '提示', message: result.code === 405 ? '未查询到您的报名信息' : (result.message || '查询失败') })
      }
    },
    async sendCode() {
      if (!this.phoneRules.test(this.form.phone)) {
        this.phoneErrorMsg = '请填写正确手机号'
        return
      }
      this.phoneErrorMsg = ''
      this.timeOut()
      await this.$http.post(this.$baseURL.index.sendCode(), { phone: this.form.phone })
    },
    timeOut() {
      let count = 60
      this.waitCode = true
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.sendCodeText = `${count}秒后重试`
        if (count === 0) {
          clearInterval(this.interval)
          this.sendCodeText = '获取验证码'
          this.waitCode = false
        }
        count--
      }, 1000)
    },
    async getGroupList() {
      if (this.groupArray.length) return
      const result = await this.$http.get(`${this.$baseURL.index.getGroupList(true)}?miceLink=${this.miceLink}`, 1)
      if (result && result.data) this.$store.commit('groupInfo/SET_GROUPARRAY', result.data)
    },
    async getInfoByOpenid() {
      if (!this.$store.state.userInfo.openid) {
        this.isSearch = true
        return
      }
      const result = await this.$http.post(this.$baseURL.index.searchByOpenid(), { miceLink: this.miceLink }, 1)
      this.isSearch = true
      if (result.code === 200 && result.data && result.data.backstageApply) {
        this.userInfo = result.data.backstageApply
        this.userInfo.hcIsOk = result.data.hcIsOk
        this.userInfo.hcMsg = result.data.hcMsg
        this.searchSuccess = true
        this.active = 1
      }
    },
    async refreshCode() {
      this.freshLoading = true
      const result = await this.$http.postParams(this.$baseURL.index.refreshCode(), { id: this.userInfo.id })
      this.freshLoading = false
      this.userInfo.code = result.code
    },
    switchType(index, type) {
      this.active = index
      if (type) this.shareType = type
    },
    changeUser(user) {
      this.shareType = 'vip'
      this.vipUserInfo.name = user.vipName
      this.vipUserInfo.phone = this.$utils.handlePhone(user.vipPhone)
    }
  },
  async activated() {
    this.miceLink = this.$route.params.miceLink || ''
    this.containsMiceLink = !!this.miceLink
    if (this.containsMiceLink) {
      this.initializing = true
      this.$store.commit('miceInfo/SET_MICE_LINK', this.miceLink)
      await Promise.all([this.getGroupList(), this.getInfoByOpenid(), this.wait(400)])
      this.initializing = false
    } else {
      this.initializing = false
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style lang="less" scoped>
@primary: #3c9cff;
@navy: #00213c;
@main: #1d2129;
@content: #4e5969;
@tips: #86909c;
@border: #f2f3f5;

.personal-center { min-height: 100vh; padding-bottom: 20px; color: @main; background: #f4f6f9; }
.loading-page { padding: 16px; }
.loading-card { overflow: hidden; margin: 0 auto 14px; padding: 18px; border-radius: 16px; background: #fff; box-shadow: 0 4px 16px rgba(0,0,0,.03); }
.loading-card-small { padding-top: 16px; padding-bottom: 16px; }
.page-content { padding: 16px; }
.card, .login-card { width: 100%; margin: 0 auto 14px; overflow: hidden; border-radius: 16px; background: #fff; box-shadow: 0 4px 16px rgba(0,0,0,.03); }
.login-card { width: calc(100% - 32px); margin-top: 16px; }
.login-card-header { padding: 20px 18px 8px; }
.login-card-header h2, .card-header h2 { margin: 0; color: @main; font-size: 16px; font-weight: 600; }
.login-card-header p { margin: 6px 0 0; color: @tips; font-size: 12px; }
.login-card /deep/ .van-form { padding: 8px 0 14px; }
.login-card /deep/ .van-cell, .profile-form-card /deep/ .van-cell { min-height: 50px; padding: 13px 18px; background: #fff; }
.login-card /deep/ .van-cell::after, .profile-form-card /deep/ .van-cell::after { right: 18px; left: 18px; border-color: @border; }
.login-card /deep/ .van-field__label, .profile-form-card /deep/ .van-field__label { width: 76px; margin-right: 14px; color: @content; font-size: 13px; font-weight: 600; }
.login-card /deep/ .van-field__control, .profile-form-card /deep/ .van-field__control { color: @main; font-size: 13px; }
.login-actions { padding: 16px 18px 8px; }
.login-actions .van-button { height: 40px; border-radius: 20px; }
.register { margin: 0 18px 6px; color: @content; font-size: 12px; text-align: right; text-decoration: underline; }
.main-profile-card { padding: 0; }
.main-card-header { padding: 22px 20px; color: #fff; text-align: center; background: linear-gradient(135deg, #001e38 0%, #003a6c 100%); }
.event-title { overflow: hidden; color: #fff; font-size: 19px; font-weight: 700; letter-spacing: 1px; line-height: 1.35; text-overflow: ellipsis; text-shadow: 0 2px 4px rgba(0,0,0,.2); white-space: nowrap; }
.main-card-body { display: flex; flex-direction: column; align-items: center; position: relative; margin-top: 0; padding: 20px 18px 20px; }
.avatar-wrapper { margin-bottom: 8px; }
.avatar { width: 72px; height: 72px; overflow: hidden; border: 3px solid #fff; border-radius: 50%; background: #e2e8f0; box-shadow: 0 6px 16px rgba(0,0,0,.1); }
.avatar img { display: block; width: 100%; height: 100%; object-fit: cover; }
.user-name { margin-bottom: 4px; color: @main; font-size: 18px; font-weight: 700; }
.user-company { margin-bottom: 12px; color: @tips; font-size: 13px; }
.status-badge { display: inline-flex; align-items: center; gap: 6px; padding: 6px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; }
.status-badge.is-pending { color: #909399; background: #f4f4f5; }
.status-badge.is-approved { color: #5ac725; background: #eaf8e6; }
.status-badge.is-failed { color: #86909c; background: #f4f5f7; }
.status-icon { font-size: 15px; font-weight: 700; }
.info-list { width: 100%; margin-top: 16px; padding-top: 16px; border-top: 1px dashed @border; }
.info-item { display: flex; justify-content: space-between; gap: 16px; min-height: 28px; font-size: 13px; line-height: 1.5; }
.info-label { flex: 0 0 64px; color: @tips; }
.info-value { flex: 1; color: @main; font-weight: 500; text-align: right; word-break: break-all; }
.state-panel { width: 100%; margin-top: 12px; padding-top: 16px; border-top: 1px dashed @border; }
.venue-list { display: flex; flex-direction: column; gap: 10px; width: 100%; }
.venue-card-item { padding: 12px; border: 1px solid @border; border-radius: 12px; background: #f8fafc; }
.venue-card-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; margin-bottom: 6px; }
.venue-name { color: @main; font-size: 13px; font-weight: 600; line-height: 1.4; }
.venue-info-row { display: flex; align-items: center; gap: 5px; margin-top: 4px; color: @tips; font-size: 11px; line-height: 1.4; }
.venue-info-icon { flex: 0 0 14px; color: #94a3b8; text-align: center; }
.tag-result { padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 600; }
.tag-result.success { color: #5ac725; background: #eaf8e6; }
.tag-result.danger { color: #f56c6c; background: #fef0f0; }
.failure-box { width: 100%; margin-top: 14px; padding: 11px 14px; border: 1px solid #f2f3f5; border-radius: 8px; color: #666; background: #f8fafc; font-size: 13px; line-height: 1.55; text-align: left; }
.failure-box-content { min-width: 0; }
.failure-box p { margin: 0; }
.failure-box .failure-title { margin-bottom: 5px; color: #4e5969; font-size: 14px; font-weight: 600; }
.qr-section { width: 100%; padding-top: 16px; text-align: center; }
.qr-section /deep/ .van-divider { margin: 0 0 12px; color: @tips; font-size: 12px; }
.qr-code-wrapper { position: relative; display: flex; justify-content: center; width: 160px; height: 160px; margin: 10px auto; padding: 0; border: 0; border-radius: 0; background: transparent; }
.qr-code-wrapper /deep/ canvas, .qr-code-wrapper /deep/ img { display: block; width: 160px !important; height: 160px !important; }
.qr-tip { margin: 0; color: @tips; font-size: 11px; line-height: 1.5; }
.loading-mask { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,.9); }
.card-header { display: flex; align-items: center; padding: 18px; border-bottom: 1px solid @border; }
.detail-info-list { display: flex; flex-direction: column; gap: 12px; padding: 18px; }
.detail-info-item { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; font-size: 13px; line-height: 1.45; }
.detail-info-label { flex: 0 0 70px; color: @tips; }
.detail-info-value { flex: 1; color: @main; font-weight: 500; text-align: right; word-break: break-all; }
.detail-info-item-venues { align-items: flex-start; }
.applied-venues { display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: flex-end; gap: 6px; }
.applied-venue-tag { display: inline-block; padding: 4px 8px; border-radius: 6px; color: @main; background: #f1f5f9; font-size: 12px; line-height: 1.3; text-align: right; white-space: nowrap; }
.personal-center /deep/ .van-nav-bar { height: 44px; background: @navy !important; }
.personal-center /deep/ .van-nav-bar__title, .personal-center /deep/ .van-nav-bar__text, .personal-center /deep/ .van-nav-bar__arrow { color: #fff; }
.personal-center /deep/ .van-nav-bar__title { font-size: 16px; font-weight: 600; }
.personal-center /deep/ .van-nav-bar::after { display: none; }
.registration-coming-overlay {
  z-index: 2000;
  bottom: 50PX;
  height: calc(100% - 50PX) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, .55);
}
.registration-coming-card {
  width: min(220px, calc(100vw - 64px));
  padding: 25px 20px 24px;
  border: 1px solid #ececec;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, .14);
  text-align: center;
}
.registration-coming-title { color: #222; font-size: 19px; font-weight: 600; letter-spacing: 1px; line-height: 1.5; }
</style>
